import styles from "./AddAddress.module.scss";
import PropTypes from "prop-types";
import config from "../../../config/index";

const AddAddress = ({ type, data, handleOnClick, id, className }) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  return (
    <div className={`${styles["addAddress"]} ${className}`}>
      <div
        className={`${styles["addAddress__section"]} d-none d-lg-block`}
        onClick={() => {
          handleOnClick(type, "add", {});
        }}
        id={id}
      >
        <img
          className={styles["addAddress-add"]}
          src={`${imagePrefix}/assets/images/plus.svg`}
          alt="add address"
        />
        <span className={styles["addAddress__address"]}>
          {data.desktop_button}
        </span>
      </div>
      <div
        className={`${styles["addAddress__tile"]} d-flex d-lg-none`}
        onClick={() => {
          handleOnClick(type, "add", {});
        }}
        id={`${id}-mob`}
      >
        <img
          className={styles["addAddress-add"]}
          src={`${imagePrefix}/assets/images/plus.svg`}
          alt="add address"
        />
        <span className={styles["addAddress__address"]}>{data.mob_button}</span>
        <img
          className={`${styles["addAddress-arrow"]}`}
          src={`${imagePrefix}/assets/images/caret-right.svg`}
          alt="add address"
        />
      </div>
    </div>
  );
};

AddAddress.propTypes = {
  type: PropTypes.oneOf(["delivery", "billing"]),
  data: PropTypes.object,
  handleOnClick: PropTypes.func,
  id: PropTypes.string,
  className: PropTypes.string,
};

AddAddress.defaultProps = {
  type: "delivery",
  data: {},
  id: "add-address",
};

export default AddAddress;
